module.exports = __webpack_public_path__ + "static/main-6cf4f4ab6a58c8ff21af4917545cae2e.png";